import { INIT_EDIT_QUOTE } from 'store/quotes/types';

import { types } from './actions';

const initialState = {
  isConfirmationModalOpen: false,
  component: null,
};

export default function confirmModal(state = initialState, action) {
  const { type } = action;

  switch (type) {
    case INIT_EDIT_QUOTE:
      return { ...initialState };
    case types.OPEN_CONFIRM_PROCESS_MATERIAL_MODAL:
      return {
        ...state,
        isConfirmationModalOpen: true,
        component: action.payload.component,
      };
    case types.CLOSE_CONFIRM_PROCESS_MATERIAL_MODAL:
      return {
        ...state,
        isConfirmationModalOpen: false,
        component: null,
      };
    case types.CONFIRM_UPDATE_PROCESS_MATERIAL_REQUEST:
      return {
        ...state,
        isConfirmationModalOpen: false,
        component: null,
      };
    default:
      return state;
  }
}

const getScope = (state) => state.modules.quotes.confirmProcessMaterialModal;

export const getIsConfirmationModalOpen = (state) =>
  getScope(state).isConfirmationModalOpen;

export const getComponent = (state) => getScope(state).component;
